import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import './global.scss';
import Header from './components/Header.tsx';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import axios from 'axios';
import React, { useEffect ,useState} from 'react';

import ConsentDetails from './components/ConsentDetails';
import Dashboard from './components/Dashboard';
import Landing from './components/Landing';
import Templates from './components/Templates';
import Thankyou from './components/Thankyou';
import Summary from './components/Summary';
import Login from './components/Login';
import LoginRedirect from './components/LoginRedirect';
import { ToastContainer, toast } from 'react-toastify';
import { BrowserRouter, Routes, Route, Navigate   } from "react-router-dom";
import Cookies from 'js-cookie';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-toastify/dist/ReactToastify.css';
import Plans from './components/Plans.tsx';
import CorporateForm from './components/ContactSales/CorporateForm.tsx';
import PurchaseDetailsForm from './components/PurchaseDetails/PurchaseDetailsForm.tsx';
import Error from './components/Error.tsx';
import PurchaseConfirmation from './components/PurchaseConfirmation.tsx';
import MyPlan from './components/MyPlan/MyPlan.tsx';
import Expired from './components/Expired.tsx';
import Tutorials from './components/Tutorials/Tutorials.tsx';
import VideoManager from './components/VideoManager/VideoManager.tsx';
import LogoPage from './components/LogoPage.tsx';
import Capture from './components/CameraCpature/Camera.tsx';
import TemplatesV2 from './components/Template/TemplatesV2.tsx';
import MobileUploader from './components/MobileUplaod/imageUplaod.tsx';
import Temp from './components/ConsentDetails/ClausesOrderPage.tsx';
import NewLogin from './components/adminLogin/AdminLogin.tsx';

//admin
import HomepageInternal from './components/Admin/pages/homepage/index.js';
import UserFeedback from './components/Admin/pages/user-feedback/index.js';
import Waitlist from './components/Admin/pages/waitlist/index.js';
import TimeTrackingCclinician from './components/Admin/pages/time Tracking Report/index.js';
import TimeTrackingPatient from './components/Admin/pages/time Tracking Report/time_tracking_patient.js';
import ActivityReport from './components/Admin/pages/activity-report/index.js';
import VideoPercentageReport from './components/Admin/pages/video-percentage-report/index.js';
import UserLogin from './components/Admin/pages/user-logins/index.js';
import UserList from './components/Admin/pages/user-list/index.js';
import CompletedConsentBundles from './components/Admin/pages/completed-consent-bundles/index.js';
import CompliancePage from './components/Admin/pages/compliance-management/index.js';
import ExistingUsersPage from './components/Admin/pages/existing-users/index.js';
import HelpPage from './components/Admin/pages/help&support/index.js';
import NewUsersPage from './components/Admin/pages/new-users/index.js';
import PatientPage from './components/Admin/pages/patient-engagement/index.js';

//user
import HomepageInternalUser from './components/User/pages/user-homepage/index.js';
import CompliancePageUser from './components/User/pages/user-compliance-management/index.js';
import ComplianceLeaderboardUser from './components/User/pages/user-compliance-leaderboard/index.js';
import HelpPageUser from './components/User/pages/user-help&support/index.js';
import PatientPageUser from './components/User/pages/user-patient-engagement/index.js';
import PasswordPrompt from './components/PasswordPrompt';

// new ui
import NewDashboard from './components/NewUi/Dashboard/Dashboard.tsx';
import TreatmentFlow from './components/NewUi/TreatmentFlow/TreatmentFlow.jsx';
import PortalWelcome from './components/NewUi/Register/PracticePortalWelcome.tsx';
import PracticeDetails from './components/NewUi/Register/PracticeDetailsPage.tsx';
import LogoManagementPage from './components/NewUi/Register/LogoManagementPage.tsx';
import SocialLinksPage from './components/NewUi/Register/SocialLinksPage.tsx'
import PortfolioGalleryPage from './components/NewUi/Register/PortfolioGalleryPage.tsx'
import ConsentTemplatesPage from './components/NewUi/Register/ConsentTemplatesPage.tsx'
import PreviewCompletePage from './components/NewUi/Register/PreviewCompletePage.tsx'
import Complete from './components/NewUi/Register/CompletePage.tsx'
import SendConsent from './components/NewUi/TreatmentFlow/SendConsentComplete.jsx';
import SummaryNew from './components/NewUi/Summary/summary.tsx';
import SummaryNewv2 from './components/NewUi/SummeryV2/Summary.tsx';
import ConsentTemplatesPagev2 from './components/NewUi/MyConsentTemplate/ConsentTemplatesPage.tsx';
import VideoManagerv2 from './components/NewUi/VideoManager/VideoManager.tsx';
import Audio from './components/NewUi/AudioRecorder/AudioRecorder.tsx';
import AudioRecorder from './components/NewUi/AudioRecorder/Audio3second.tsx';



// Create a client
const queryClient = new QueryClient();
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

axios.defaults.headers.common.Authorization =  `Bearer ${Cookies.get('token')}`; 
//axios.defaults.headers.common.Authorization =  `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI3NSIsImV4cCI6MTc4NDU1NzAzNn0.yPMxxGFgiy4OUTEAF6q_gLd_LUyoFJHcKqJ-cN9a23s`;
// axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  response => {
      return response;
  },
  error => { 
      let status = 'unknown';
      if (error.response) {
          status = error.response.status;
      }
      switch (status) {
          case 401: {
       
            window.location.href='/login';
              Cookies.set('token', '');
              break;
          }
          case 422: {
              window.location.href='/dashboard';
              break;
          }
          case 402: {
            window.location.href='/expired';
            break;
          }
          case 403: {
            window.location.href='/login';
            Cookies.set('token', '');
            break;
          }
          default: {
              return Promise.reject(error);
          }
      }
  }
);

function App() {
const [isAuthenticated, setIsAuthenticated] = useState(false);
const [showPasswordPrompt, setShowPasswordPrompt] = useState(true);

  const handlePasswordSubmit = () => {
    setIsAuthenticated(true); 
    setShowPasswordPrompt(false); 
  };
  const handlePasswordCancel = () => {
    setShowPasswordPrompt(false); 
  };
  const theme = createTheme({
    palette: {
      primary: {
        main: '#ec7c04'
      },

      secondary: {
        main: '#243474'
      }
    }
  });

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <div className="App">
          <BrowserRouter>
            {/* <Header /> */}
            <Routes>
              <Route path="/" element={<><Header /><LogoPage /></>} />
              <Route path="/old-dashboard" element={<><Header /><Dashboard /></>} />
              <Route path="/login" element={<><Login /></>} />
              <Route path="/mobile_uploader" element={<><Header /><MobileUploader /></>} />
              <Route path="/tutorials" element={<><Header /><Tutorials /></>} />            
              <Route path="/dentally_auth_callback" element={<><Header /><LoginRedirect /></>} />
              <Route path="/plans" element={<><Header /><Plans /></>} />
              <Route path="/expired" element={<><Header /><Expired /></>} />
              <Route path="/my-plan" element={<><Header /><MyPlan /></>} />
              <Route path="/order/success" element={<><PurchaseConfirmation /></>} />
              <Route path="/order/cancel" element={<><Header /><Error /></>} />
              <Route path="/contact-sale" element={<><Header /><CorporateForm /></>} />
              <Route path="/purchase-details" element={<><Header /><PurchaseDetailsForm /></>} />
              <Route path=":consentBundleId/thankyou" element={<><Header /><Thankyou /></>} />
              <Route path=":consentBundleId/summary" element={<><Header /><Summary /></>} />
              <Route path=":consentBundleId" element={<><Header /><ConsentDetails /></>} />
              {/* <Route path="/video-gallery" element={<><VideoManager /></>} /> */}
              <Route path="/capture" element={<><Header /><Capture /></>} />
              <Route path="/TEMP" element={<><Header /><Temp /></>} />
              <Route path="/templates" element={<><ConsentTemplatesPagev2 /></>} />
              
            {/* new ui */}
              
              <Route path="/dashboard" element={<><NewDashboard /></>} />
              <Route path="/new-consentBundle" element={<><TreatmentFlow /></>} />
              <Route path="/welcome" element={<><PortalWelcome /></>} />
              <Route path="/practiceDetails" element={<><PracticeDetails /></>} />
              <Route path="/logoManagement" element={<LogoManagementPage />} />
              <Route path="/socialLinks" element={<SocialLinksPage />} />
              <Route path="/portfolioGallery" element={<PortfolioGalleryPage />} />
              <Route path="/consentTemplates" element={<ConsentTemplatesPage />} />
              <Route path="/previewComplete" element={<PreviewCompletePage />} />
              <Route path="/complete" element={<Complete />} />
              <Route path="/sendConsent/:id" element={<SendConsent />} />
              <Route path="/summary-new/:consentBundleId" element={<SummaryNewv2 />} />
              <Route path="/templatesPagev2" element={<ConsentTemplatesPagev2 />} /> 
              <Route path="/video-gallery" element={<VideoManagerv2 />} /> 
              <Route path="/audio-recorder" element={<Audio />} />
              <Route path="/audio" element={<AudioRecorder />} />
           
              {/* <Route path="/templatesPagev2" element={<ConsentTemplatesPagev2 />} /> */}

              <Route
                path="/admin-login"
                element={
                  <NewLogin
                    onLoginSuccess={() => {
                      setIsAuthenticated(true);
                      window.location.href = "/homepage_admin";
                    }}
                  />
                }
                
              />

          {/* admin */}
            <Route path="/homepage_admin" element={<HomepageInternal />} />
            <Route path="/compliance_management" element={<CompliancePage />} />
            <Route path="/existing_users" element={<HomepageInternal />} />
            <Route path="/new_users" element={<NewUsersPage />} />
            <Route path="/patient_engagement" element={<PatientPage />} />
            <Route path="/user_feedback" element={<UserFeedback />} />
            <Route path="/user_waitlist" element={<Waitlist />} />
            <Route path="/time_tracking_clinician_report" element={<TimeTrackingCclinician />} />
            <Route path="/time_tracking_patient_report" element={<TimeTrackingPatient />} />
            <Route path="/activity_report" element={<ActivityReport />} />
            <Route path="/video_watch_Percentage_Report" element={<VideoPercentageReport />} />
            <Route path="/user_Logins" element={<UserLogin />} />
            <Route path="/help&support" element={<HelpPage />} />
            <Route path="/user_List" element={<UserList />} />
            <Route path="/completed-Consent-bundles" element={<CompletedConsentBundles />} />

          {/* user */}
              <Route 
                path="/homepage_user" 
                element={isAuthenticated ? <HomepageInternalUser /> : <Navigate to="/password_user" />} 
              />
              <Route
                path="/compliance_management_user"
                element={isAuthenticated ? <CompliancePageUser /> : <Navigate to="/password_user" />}
              />
              <Route
                path="/patient_engagement_user"
                element={isAuthenticated ? <PatientPageUser /> : <Navigate to="/password_user" />}
              />
              <Route
                path="/compliance_leaderboard_user"
                element={isAuthenticated ? <ComplianceLeaderboardUser /> : <Navigate to="/password_user" />}
              />
              <Route
                path="/help&support_user"
                element={isAuthenticated ? <HelpPageUser /> : <Navigate to="/password_user" />}
              />
              <Route
                path="/password_admin"
                element={
                  showPasswordPrompt ? (
                    <PasswordPrompt onSubmit={handlePasswordSubmit} onCancel={handlePasswordCancel} />
                  ) : (
                    <Navigate to="/homepage_admin" /> 
                  )
                }
              />              
              <Route
                path="/password_user"
                element={
                  showPasswordPrompt ? (
                    <PasswordPrompt onSubmit={handlePasswordSubmit} onCancel={handlePasswordCancel} />
                  ) : (
                    <Navigate to="/homepage_user" /> 
                  )
                }
              />
              <Route path="/*" element={<Navigate to="/dashboard" />} /> 
            </Routes>
          </BrowserRouter>
          <ToastContainer />
        </div>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;